import React, { useContext } from "react";
import "./Toggle.css";
import Sun from "@iconscout/react-unicons/icons/uil-sun";
import Moon from "@iconscout/react-unicons/icons/uil-moon";
import { themeContext } from "../Context";

export const Toggle = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <button
      type="button"
      className={`toggle ${darkMode ? "is-dark" : "is-light"}`}
      onClick={() => theme.dispatch({ type: "toggle" })}
      aria-label={darkMode ? "Activer le mode jour" : "Activer le mode nuit"}
      title={darkMode ? "Mode jour" : "Mode nuit"}
    >
      <Moon />
      <Sun />
      <span
        className="t-button"
        style={darkMode ? { left: "2px" } : { right: "2px" }}
      />
    </button>
  );
};

export default Toggle;
